module.exports = __webpack_public_path__ + "static/media/upload_images.2b9d9e9e.svg";